import { getSelectedKey } from './getSelectedKey';

export function getIsPossibleToDeleteCache(state) {
	const configKey = getSelectedKey(state);
	return Boolean(configKey);
}
